module.exports = __webpack_public_path__ + "img/qr-code2.b46b99cb.png";